import { HardDrive } from 'lucide-react'

import { formatBytes } from '@/lib/utils'

type StorageUsageProps = {
  totalSize: number
}

export const StorageUsage = ({ totalSize }: StorageUsageProps) => {
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <HardDrive size={16} />
      <span>合計容量: {formatBytes(totalSize)}</span>
    </div>
  )
}
